module.exports = __webpack_public_path__ + "files/bb67ba6ed80dfe911d2777c79017e77e.png";